import React, { createContext, useContext } from "react";
import useAppIOSConnection, {
  Response,
  Type,
  UseAppIOSConnection,
} from "./useAppIOSConnection";

const AppIOSConnectionContext = createContext<{
  requestPhotoDataAtNeptune(id: string, data: any): boolean;
  requestDeviceDataAtNeptune(id: string, data: any): boolean;
  receivedData: Response;
  clear(): void;
  isConnected: {
    [Type.PHOTO]: boolean;
    [Type.DEVICE]: boolean;
  };
}>({} as any);

interface AppIOSConnectionProviderProps extends UseAppIOSConnection {
  children: any;
}

export const AppIOSConnectionProvider: React.FC<
  AppIOSConnectionProviderProps
> = ({ children, ...other }) => {
  const state = useAppIOSConnection(other);

  return (
    <AppIOSConnectionContext.Provider value={state}>
      {children}
    </AppIOSConnectionContext.Provider>
  );
};

export const useAppIOSConnectionProvider = () => {
  return useContext(AppIOSConnectionContext);
};
